/* Skinny Genie redesign: Contract Manufacturing page behaviour. Ported from
   contract-manufacturing-mockup.html: the "who we manufacture for" tab
   switcher and the sticky scroll-spy sub-nav. */

function showServeTab(key, btn){
  var wrap = btn.closest('.content-section');
  if(!wrap) return;
  var tabs = wrap.querySelectorAll('.cm-serve-tab-btn');
  tabs.forEach(function(b){
    b.classList.remove('active');
    b.setAttribute('aria-selected', 'false');
  });
  btn.classList.add('active');
  btn.setAttribute('aria-selected', 'true');
  var panels = wrap.querySelectorAll('.cm-serve-panel');
  panels.forEach(function(p){
    p.classList.toggle('active', p.getAttribute('data-serve-panel') === key);
  });
}

document.addEventListener('DOMContentLoaded', function(){
  var subnav = document.querySelector('.page-subnav');
  if(!subnav) return;
  var links = Array.prototype.slice.call(subnav.querySelectorAll('.page-subnav-link'));
  var sections = links.map(function(link){
    return document.getElementById(link.getAttribute('href').slice(1));
  }).filter(Boolean);

  var setActive = function(id){
    links.forEach(function(link){
      link.classList.toggle('active', link.getAttribute('href') === '#' + id);
    });
  };

  if('IntersectionObserver' in window){
    var observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          setActive(entry.target.id);
        }
      });
    }, { rootMargin: '-45% 0px -50% 0px', threshold: 0 });
    sections.forEach(function(section){ observer.observe(section); });
  } else {
    window.addEventListener('scroll', function(){
      var scrollPos = window.scrollY + 120;
      var current = sections[0];
      sections.forEach(function(section){
        if(section.offsetTop <= scrollPos){ current = section; }
      });
      if(current){ setActive(current.id); }
    }, { passive: true });
  }

  links.forEach(function(link){
    link.addEventListener('click', function(e){
      var target = document.getElementById(link.getAttribute('href').slice(1));
      if(target){
        e.preventDefault();
        var top = target.getBoundingClientRect().top + window.pageYOffset - (subnav.offsetHeight + 12);
        window.scrollTo({ top: top, behavior: 'smooth' });
        setActive(target.id);
      }
    });
  });
});
